import axios from "axios";

const { REACT_APP_ENDPOINT_BASE } = process.env

const Client = (headers: any) => axios.create({
  baseURL: `${REACT_APP_ENDPOINT_BASE}`,
  headers,
});

/* El código exporta una variable constante llamada "Headers" que contiene un objeto con una
propiedad "headers". La propiedad `headers` es un objeto que contiene pares clave-valor para
varios encabezados HTTP. */
const Headers = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

/* El código exporta una variable constante llamada "HeadersFormData". Esta variable contiene un objeto
con una propiedad llamada "encabezados". La propiedad `headers` es un objeto que contiene pares
clave-valor para varios encabezados HTTP. En este caso, incluye encabezados para autorización, tipo
de contenido y tipo de aceptación específicamente para manejar datos de formularios de varias
partes. */
const HeadersFormData = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    Accept: 'multipart/form-data',
    'Content-Type': 'multipart/form-data',
  },
};

const http = {
  Client,
  Headers,
  HeadersFormData,
}

export { http }